import {AfterViewInit, Component, Input} from '@angular/core';
import {DbTextPipe} from "../../pipes/db-text.pipe";
import {NgIf} from "@angular/common";
import {Store} from "@ngrx/store";
import * as fromStore from "../../../store";

@Component({
    selector: 'db-something-wrong',
    templateUrl: './something-wrong.component.html',
    styleUrls: ['./something-wrong.component.scss'],
    imports: [
        DbTextPipe,
        NgIf
    ]
})
export class SomethingWrongComponent implements AfterViewInit {
@Input() descText: string;

  constructor(
    private _store: Store<fromStore.DbStoreState>,
  ) {}


  ngAfterViewInit() {
    // Attach a click listener to the anchor tag
    const customerCareLink = document.querySelector('.customer-care-link');
    if (customerCareLink) {
      customerCareLink.addEventListener('click', this.openChat.bind(this));
    }
  }

  private openChat() {
      window['Smooch']?.open();
      this._store.dispatch(new fromStore.ToggleChatOverlay(false));
  }

}
